
import { useContext, useState } from 'react';
import './style/payAlert.css';
import { AppContext } from '../../../contextApi/ContextApi';
import { ClientContext } from '../../../contextApi/ClientContext';

export default function PayAlert({ setPayAlertFlag, setProblem, website, isMissingAddress, isMissingPaymentMethod, setNeedUpdate, needUpdate, _finalPrice }) {
  const {primary_color, accent_color, secondary_color, currentUser, setCurrentUser, setToastMessage, messagesOptions, setCurrentWebsite, getTodayDate} = useContext(AppContext);
  const { handleClientPayment, isPaying } = useContext(ClientContext);

  const [hoverYes, setHoverYes] = useState(false);
  const [hoverNo, setHoverNo] = useState(false);

  const handleChangeDisplay=()=>{
    setPayAlertFlag(false);
    setNeedUpdate(true);
  }
  return (
    <div className='alertBeforePay' style={{backgroundColor:secondary_color, textShadow:`2px 2px 10px ${primary_color}`, color:accent_color}}>
      <h1 style={{color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}}>רק רגע..</h1>
      <h2>האם ברצונך לסיים את הקנייה?</h2>
      
      <div>
          <button
            className='alertBeforePay_btn'
            onMouseEnter={()=>{setHoverYes(true)}}
            onMouseLeave={()=>{setHoverYes(false)}}
            style={{backgroundColor:hoverYes ? primary_color : accent_color, color:hoverYes ? accent_color : primary_color}}
            onClick={()=>{
              return isMissingAddress||isMissingPaymentMethod ? handleChangeDisplay() : handleClientPayment(needUpdate, getTodayDate, website, currentUser, setCurrentUser, setCurrentWebsite, setProblem, setToastMessage, messagesOptions, isMissingPaymentMethod, isMissingAddress, _finalPrice)
            }}
            disabled={isPaying}>{isPaying?"טוען..":"כן"}
          </button>
          <button className='alertBeforePay_btn' onMouseEnter={()=>{setHoverNo(true)}} onMouseLeave={()=>{setHoverNo(false)}} style={{backgroundColor:hoverNo ? primary_color : accent_color, color:hoverNo ? accent_color : primary_color}} onClick={()=>{setPayAlertFlag(false)}} disabled={isPaying}>לא</button>
      </div>
    </div>
  )
}
